<template>
  <input
    ref="input"
    v-model="localValue"
    class="base-texteditable"
    :style="customStyle"
    :class="customClass"
    :placeholder="placeholder"
    @keydown.enter="complete()"
    @blur="blur()"
  >
</template>

<script>
import whichbrowser from '../mixins/whichbrowser';

export default {
  name: 'BaseTexteditable',
  mixins: [whichbrowser],
  props: {
    defaultValue: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    maxWidth: {
      type: String,
      required: true,
    },
    placeholder: {
      default: '',
      type: String,
      required: false,
    },
    customWidth: {
      type: String,
      required: false,
      default: '',
    },
    isHeading: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localValue: '',
    };
  },
  computed: {
    customClass() {
      let customClass = 'browserClass';
      if (this.isHeading) {
        customClass += ' base-heading';
      }
      return customClass;
    },
    customStyle() {
      let customStyle = '';
      if (this.maxWidth) {
        customStyle += `max-width: ${this.maxWidth}; `;
      }
      if (this.customWidth) {
        customStyle += `width: ${this.customWidth}; `;
      }
      return customStyle;
    },
  },
  watch: {
    localValue() {
      this.$emit('input', this.localValue);
    },
    value: {
      handler(val) {
        this.localValue = val;
      },
      immediate: true,
    },
  },
  methods: {
    focus() {
      this.$refs.input.focus();
    },
    complete() {
      this.$emit('complete');
      this.localValue = this.localValue || this.defaultValue;
    },
    blur() {
      this.$emit('blur');
      this.localValue = this.localValue || this.defaultValue;
    },
  },
};
</script>

<style lang="scss" scoped>
.base-texteditable {
  border: none !important;
  outline: none;
  background: none;
  line-height: 1.25;

  &.with-border {
    border-bottom: solid 0.25px #333;
    &.is-chrome {
      border-bottom: solid 0.25px #333;
    }
  }

  &.is-chrome {
    border: none;
    font-size: 17px;
    line-height: 1.25;
  }
}
.is-invalid {
  border: solid 1px #CB444A;
  border-radius: 3px
}
input::placeholder {
    color: #AAAAAA;
}
.base-heading {
  font-family: $font-family-serif;
  line-height: 1.2;
  color: #333333;
  letter-spacing: 0.19px;
  width: 100%;
  font-size: 1.25rem;
}
</style>
